import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IStoreDataV3, Store } from '@df/catalog/store/store';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';

@Component({
    selector: 'page-store-finder-store-status',
    templateUrl: 'page-store-finder-store-status.html',
    imports: [TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageStoreFinderStoreStatusComponent {
    /**
     * Store
     */
    @Input()
    store?: Store<IStoreDataV3>;
}
